var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book"},[_c('v-chart',{ref:"book",attrs:{"option":_vm.option,"init-options":_vm.initOptions,"autoresize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }